"use strict";

define('rs/form/formobjects/sponsor.finder/sponsor.finder.formobject',['rs/form/abstract.form.entity', 'rs/form/formobjects/base.formobject', 'rs/form/formobjects/sponsor.finder/sponsor.finder.formobject.view', 'rs/models/sponsor', 'rs/modals/sponsor.finder/sponsor.finder.controller', 'rs/helper', 'e3-table'], function (AbstractFormEntity, BaseFormObject, SponsorFinderFormObjectView, SponsorModel, SponsorFinder, helper, E3Table) {
  var SponsorFinderFormObject = BaseFormObject.extend({
    propertiesDefinitions: ['name', 'label', 'hasMultiple', 'required', 'text', 'description', 'helpText'],
    properties: ['displayTable', 'hasMultiple', 'assignmentType', 'sponsors', 'ariaControlsId'],
    columns: [{
      name: 'name',
      displayName: 'Name',
      width: '95%'
    }, {
      accessibleDisplayName: 'Remove',
      remove: true,
      isButton: true,
      className: 'remove-sponsor-finder-cell',
      width: '5%'
    }],
    isAnswerable: true,
    initialize: function initialize() {
      var columns = this.columns.slice(0);
      this.setSponsors([]);
      this.setHasMultiple(true);
      this.setAssignmentType('IRB_SPONSOR');
      this._super.apply(this, arguments);
      this.sync('sponsors');
      this.setAriaControlsId('fo-' + this.getId());
      if (!this.getFormController().canEditDocument()) {
        columns.pop();
        columns[columns.length - 1].width = '100%';
      } else {
        columns[columns.length - 2].width = '95%';
      }
      this.setDisplayTable(new E3Table.AccordionController({
        columns: columns,
        delegate: this,
        selectable: false,
        theme: 'rs',
        ariaLabel: 'current selection for ' + this.getLabeledText(),
        ariaDescribedBy: this.getId() ? "fo-" + this.getId() + '-text' : ''
      }));
    },
    importAnswers: function importAnswers() {
      var assignments = this.getFormController().getAssignments(),
        sponsors = null;
      this.getFormController().addAssignmentFormObject(this);
      if (!this.getFormController().hasAnswers()) {
        sponsors = assignments.getSponsorsByAssignmentType(this.getAssignmentType());
        if (!this.getHasMultiple() && sponsors.length > 1) {
          sponsors = sponsors.slice(0, 1);
        }
        if (sponsors.length > 0) {
          this.setSponsors(sponsors);
          this.requestValueChange();
          this.getSectionController().setUnsavedChanges(true);
        }
      }
    },
    getCompareValue: function getCompareValue() {
      return JSON.stringify((_.pluck(this.getSponsors(), 'id') || []).sort());
    },
    setupView: function setupView() {
      this.setView(new SponsorFinderFormObjectView());
    },
    updateSponsorInfo: function updateSponsorInfo() {
      var that = this,
        sponsors = this.getSponsors();
      return this._updateSponsorsDeferred = Promise.map(sponsors, function (sponsor) {
        return SponsorModel.requestDetails(sponsor.id).ignoreErrors();
      }).then(function (newSponsors) {
        if (_.isArray(newSponsors)) {
          that.setSponsors(newSponsors);
        }
      });
    },
    setSponsors: function setSponsors(value) {
      if (_.isArray(value)) {
        for (var i = 0, len = value.length, sponsor; i < len; i++) {
          sponsor = value[i];
          if (!(sponsor instanceof SponsorModel)) {
            value[i] = new SponsorModel(sponsor);
          }
        }
      }
      this.set('sponsors', value);
    },
    loadData: function loadData() {
      var data = this.getFormController().getFormObjectDataByID(this.getId()),
        sponsors = [];
      try {
        sponsors = JSON.parse(data);
      } catch (e) {}
      if (_.isArray(sponsors)) {
        this.setSponsors(SponsorModel.models(sponsors), {
          silent: true
        });
      }
      this.updateSponsorInfo();
    },
    loadAssignmentsToBuilder: function loadAssignmentsToBuilder(ab) {
      var assignmentType = this.getAssignmentType(),
        sponsors = this.getSponsors(),
        sponsor = null,
        i = 0;
      if (assignmentType) {
        if (sponsors.length) {
          for (i = 0; sponsor = sponsors[i]; ++i) {
            ab.addSponsor(sponsor, assignmentType, {
              rawType: true
            });
          }
        } else {
          ab.addSponsor(null, assignmentType, {
            rawType: true
          });
        }
      }
    },
    checkValue: function checkValue() {
      if (this.getFormController().isPreviewMode()) {
        return true;
      }
      return this.getSponsors().length > 0;
    },
    getValue: function getValue() {
      return JSON.stringify(this.getSponsors());
    },
    setValue: function setValue(v) {
      var sponsors = [];
      try {
        sponsors = JSON.parse(v);
      } catch (e) {}
      this.setSponsors(sponsors);
    },
    requestValueChange: function requestValueChange() {
      this.trigger('change:value');
    },
    refreshSponsorsPropertyOnView: function refreshSponsorsPropertyOnView() {
      this.getView().refreshFormObjectWithValue();
    },
    removeSponsorAtIndex: function removeSponsorAtIndex(index) {
      if (this.isReadOnly()) {
        return;
      }
      var that = this;
      return Promise.resolve(this._updateSponsorsDeferred).then(this.testSet.proxy(this)).lastly(this.getFormController().showLoading()).then(function () {
        var sponsors = that.getSponsors();
        sponsors.splice(index, 1);
        that.trigger('change:sponsors');
        that.requestValueChange();
      });
    },
    toJSON: function toJSON() {
      var json = this._super.apply(this, arguments),
        assignmentType = this.getAssignmentType();
      json.hasMultiple = this.getHasMultiple();
      json.assignmentType = assignmentType;
      return json;
    },
    requestSponsorModal: function requestSponsorModal() {
      var that = this,
        sponsors = null;
      return SponsorFinder.show({
        items: this.getSponsors(),
        multiSelect: this.getHasMultiple(),
        ariaControls: this.getAriaControlsId()
      }).then(function (_sponsors) {
        sponsors = _sponsors;
        return that.testSet();
      }).then(function () {
        that.setSponsors(sponsors || []);
        that.requestValueChange();
      });
    },
    viewIsReady: function viewIsReady() {
      this._super.apply(this, arguments);
      this.getDisplayTable().setup(this.getView().getDisplayContainer());
      this.getDisplayTable().start();
    },
    getData: function getData() {
      return this.getSponsors() || [];
    },
    removeTableItem: function removeTableItem(item) {
      return this.removeSponsorAtIndex(item.index);
    },
    isTableItemSelectable: function isTableItemSelectable() {
      return false;
    }
  }, {
    getTypeString: function getTypeString() {
      return 'SponsorFinder';
    },
    propertiesDefinitions: _.extend({}, AbstractFormEntity.propertiesDefinitions, {
      'hasMultiple': {
        name: 'hasMultiple',
        bool: true,
        displayName: 'Allow Multiple'
      }
    })
  });
  return SponsorFinderFormObject;
});

